"use client";

import type { PropsWithChildren } from "react";

import { Alert, type AlertRootProps, type SvgIcon } from "../../components";

export type BasicAlertProps = PropsWithChildren<{
  title: string;
  Icon?: SvgIcon;
  type?: AlertRootProps["type"];
  className?: string;
  onClose?: () => void;
}>;

const BasicAlert = ({ type = "primary", title, children, onClose, className, Icon }: BasicAlertProps) => {
  return (
    <Alert.Root type={type} orientation="horizontal" className={className}>
      <Alert.IconLayout Icon={Icon} title={title}>
        {typeof children === "string" ? <p>{children}</p> : children}
      </Alert.IconLayout>
      {onClose && <Alert.Close onClick={onClose} />}
    </Alert.Root>
  );
};

export default BasicAlert;
